import { render, staticRenderFns } from "./CreatePayrollPopup.vue?vue&type=template&id=0e4a2813"
import script from "./CreatePayrollPopup.vue?vue&type=script&lang=js"
export * from "./CreatePayrollPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports